<template>
  <v-card class="ma-3">
    <base-loading v-if="loading" />
    <div v-else>
      <v-card-title style="justify-content: center; font-size: 24px">
        <v-row justify="center">
          <v-col cols="12">
            <v-row justify="center"> Relatório Promilat </v-row>
          </v-col>
          <v-col cols="12">
            <v-row justify="center">{{ relatorio.NumeroVisita }}ª visita</v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <InformacoesGeraisCPP :relatorio="relatorio" />
      <IndicadoresQualidadeCPP :relatorio="relatorio" />
      <ImagensAnexoCPP :relatorio="relatorio" />
      <v-col cols="12">
        <v-row justify="center">
          <v-btn color="primary" @click="export_PDF">
            <v-icon style="margin-right: 6px"> mdi-file-document </v-icon>
            <span style="font-weight: bold; font-size: 16px">Exportar PDF</span>
          </v-btn>
        </v-row>
      </v-col>
      <v-row justify="center">
        <v-dialog v-model="dialogProgressPDF" persistent max-width="430">
          <v-card>
            <v-card-title class="text-h3"> Aguarde! </v-card-title>
            <v-card-title class="text-h3">
              Estamos preparando seu relatório.
            </v-card-title>
            <v-card-text>
              <div class="text-center">
                <v-progress-circular :size="40" indeterminate color="teal">
                </v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import exportPDF from '../../../../services/reports/RelatorioPDFPromilat'
import { exportReport } from '../../../../utils/report'
import ImagensAnexoCPP from './ImagensAnexo'
import IndicadoresQualidadeCPP from './IndicadoresQualidade'
import InformacoesGeraisCPP from './InformacoesGerais'

export default {
  components: {
    IndicadoresQualidadeCPP,
    InformacoesGeraisCPP,
    ImagensAnexoCPP,
  },

  props: {
    codRelatorio: {
      type: String,
      default: () => '',
    },
    draft: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialogProgressPDF: false,
      loading: true,
      relatorio: null,
    }
  },
  mounted() {
    if (!this.codRelatorio) {
      this.$router.push({ path: `/${this.$user.get().role}/relatorios/cpp` })
    } else {
      this.getRelatorio()
    }
  },
  methods: {
    exportPDF,
    getRelatorio() {
      this.api.get.relatorioccs(this.codRelatorio, this.draft).then(data => {
        this.relatorio = data
        this.loading = false
      })
    },

    async exportRel(relatorio) {
      if (!relatorio) relatorio = this.relatorio

      await this.exportPDF(relatorio)
    },
    alert() {
      this.Swal.fire({
        title: 'Atenção',
        text: 'Em Desenvolvimento!!!',
        icon: 'warning',
      })
    },

    async export_PDF() {
      this.dialogProgressPDF = true
      await exportReport({
        report: this.relatorio,
        exportReport: this.exportPDF,
      })
      this.dialogProgressPDF = false
    },
  },
}
</script>
